import React from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import IndividualProduct from '../components/individualProduct';
import ProductsBanner from "../components/ProductsBanner";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import { Helmet } from "react-helmet";
const BloodHemoglobin2 = () => {
  const title = "Dr. Chek D - Portable Hemoglobin Meter for Accurate Testing";
  const description =
    "Dr. Chek D Hemoglobin Meter provides fast and accurate hemoglobin testing. Ideal for home and professional use, featuring a portable and easy-to-use design.";
    
    const productData = {
        name: "Dr. Chek H+",
        image: "/images/Dr Chek H+_270x270.webp",
        "description":"The Dr. Chek H+ Hemoglobin Meter utilizes advanced absorbance spectroscopy for unparalleled hemoglobin testing precision. This Hb meter delivers highly accurate hemoglobin levels without the need for coding, simplifying the process for users. Experience reliable hemoglobin measurement with this innovative device, ideal for point of care hemoglobin testing. The Dr. Chek H+ ensures quick and precise results, eliminating coding errors and enhancing user convenience. Monitor hemoglobin levels effectively with this cutting-edge hemoglobin analyzer, designed for both professional and home use.Discover the ease of no coding hemoglobin testing with Dr. Chek H+",
        features: [
          "Highly Accurate Results",
          "World’s fastest testing time of 3 Seconds",
          "Ease of Sampling",
          "Minimal Sample Volume",
          "No Coding",
          "Auto Calibration"
        ],
        "brochure": {
      "pages": [
        "/images/Dr-ChekH+-Hemoglobin-Cuvettes-Analyzer-brochure-page-1.jpg",
        "/images/Dr-ChekH+-Hemoglobin-Cuvettes-Analyzer-brochure-page-2.jpg",
        
      ],
      "url": "/D-Chek-H+-Hemoglobin-Cuvettes-Analyzer-brochure.pdf"
    }
  };
    
  return (
    <div>
       <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content="Hemoglobin meter, Hemoglobin testing, Portable hemoglobin meter, Hemoglobin analyzer, Hb meter, Hemoglobin test kit, Point of care hemoglobin testing, Best hemoglobin meter, Digital hemoglobin analyzer, Accurate hemoglobin test device, Blood hemoglobin measurement, FDA-approved hemoglobin meter, Home hemoglobin monitoring, Handheld Hb meter, Buy hemoglobin meter online, Affordable hemoglobin test kit, Quick hemoglobin level check, Medical-grade hemoglobin tester"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourwebsite.com" />
      </Helmet>
        <Header/>
        <ProductsBanner
        title="Dr. Chek H+"
        backgroundImage="/images/dr-chek-banner-001.png"
        
        backgrond="cover"
        height="400px"
      />
         <IndividualProduct product={productData} />
         <Footer/>
        <WhatsAppFloatingButton/>
    </div>
  )
}
export default BloodHemoglobin2